import { render, staticRenderFns } from "./modelForm.vue?vue&type=template&id=9970475e&scoped=true&"
import script from "./modelForm.vue?vue&type=script&lang=js&"
export * from "./modelForm.vue?vue&type=script&lang=js&"
import style0 from "./modelForm.vue?vue&type=style&index=0&id=9970475e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9970475e",
  null
  
)

export default component.exports